module.exports = __webpack_public_path__ + "img/logo.751563d3.svg";